var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0278 10.681C8.71198 10.681 7.6508 9.64759 7.6508 8.36337C7.6508 7.07915 8.71198 6.04576 10.0278 6.04576C11.3437 6.04576 12.4049 7.07915 12.4049 8.36337C12.4049 9.64759 11.3437 10.681 10.0278 10.681ZM15.0366 3.23653C13.6995 1.97237 11.8955 1.25 10.0172 1.25C8.13894 1.25 6.32434 1.96234 4.99787 3.23653C3.66079 4.52075 2.91797 6.25645 2.91797 8.08245C2.91797 11.1224 4.66891 13.7812 6.36678 15.6373C7.22633 16.5804 8.06466 17.3328 8.70136 17.8546C9.03033 18.1255 9.28501 18.3161 9.46541 18.4666C9.56091 18.5368 9.62459 18.587 9.68826 18.6271L9.74131 18.6672H9.76254C9.9111 18.7776 10.0915 18.7776 10.2401 18.6672H10.2613L10.3143 18.6171C10.3143 18.6171 10.4417 18.5268 10.5372 18.4565C10.7176 18.3161 10.9935 18.1154 11.3012 17.8445C11.9379 17.3228 12.7975 16.5804 13.6358 15.6272C15.3337 13.7711 17.0846 11.1124 17.0846 8.07242C17.0846 6.24642 16.3312 4.52075 15.0047 3.24656H15.0366V3.23653Z",
    fill: "#769DFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9987,
    cy: 8.33366,
    r: 2.60417,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.e39457e0a2d424ba8bc8adbfac48eb0d.svg";
export { ForwardRef as ReactComponent };